import { http } from '../api/client';

export const commentService = {
    getComments: (ideaId) => http.get(`/ideas/${ideaId}/comments`),
    createComment: (ideaId, data) => http.post(`/ideas/${ideaId}/comments`, data),
    editComment: (commentId, data) => http.post(`/comments/${commentId}/edit`, data),
    deleteComment: (commentId) => http.post(`/comments/${commentId}/delete`, {}),
};
